import classNames from 'classnames';

import { SerializeTextLeaf } from '../textLeaf/Text';
import { emoji } from './Emoji.css';
import type { EmojiProps } from './Emoji.types';
import { emojiShortcodeMap } from './emojiShortcodeMap.generated';

const Emoji = ({ element, children }: EmojiProps) => {
  const { name } = element?.attrs || {};

  const emojiAsText = name ? emojiShortcodeMap[name] : undefined;

  if (!emojiAsText) {
    return null;
  }

  return (
    <SerializeTextLeaf
      leaf={{
        text: emojiAsText,
      }}
      className={classNames(emoji)}
    >
      {children}
    </SerializeTextLeaf>
  );
};

export { Emoji };
